<template>
  <div>
    <div>
      <ul :class="$style['header-tabs']">
        <li
          v-for="(tab, index) in tabs"
          :class="[$style['header-tab'], tab.route === activeTab ? $style['header-tab--active']: []]"
          :key="index"
          @click="changeTab(tab.route)"
        >
          <slot
            :tab="tab"
            name="header"
          />
        </li>
      </ul>
    </div>
    <div
      v-for="(tab, index) in tabs"
      v-if="tab.route === activeTab"
      :class="$style['tab-content']"
      :key="index"
    >
      <slot
        :tab="tab"
        name="content"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DsTabsBox",
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    defaultActiveTab: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeTab: this.defaultActiveTab
    };
  },
  watch: {
    defaultActiveTab(value) {
      this.activeTab = value;
    }
  },
  methods: {
    changeTab(route) {
      this.$emit("tabChanged", route);
    }
  }
};
</script>

<style lang="scss" module>
@import "~@theme/scss/_variables.scss";
@import "~@theme/scss/_mixins.scss";

$radius: 5px;

.header-tabs {
  display: flex;
  align-items: center;
  margin: 0px -4px;
  align-items: stretch;
  @include mobile() {
    flex-direction: row;
  }
}
.header-tab {
  background-color: $ultra-light-blue-color;
  margin: 0px 4px;
  padding: 19px 16px;
  padding-bottom: 12px;
  padding-right: 85px;
  border-top-left-radius: $radius;
  border-top-right-radius: $radius;
  color: $light-gray-color;
  font-weight: 500;
  line-height: 24px;
  font-weight: 600;
  @include fluid-font($font-big-size, true);
  cursor: pointer;
  user-select: none;
  &--active {
    background-color: #fff;
    color: $black-blue-color;
  }
  @include mobile() {
    padding: 9px 8px;
  }
}
.tab-content {
  h2 {
    color: $light-gray-color;
    font-weight: 600;
    @include fluid-font($font-big-size, true);
  }
  background-color: #fff;
  padding: 19px 16px;
  border-bottom-left-radius: $radius;
  border-bottom-right-radius: $radius;
  border-top-right-radius: $radius;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-tabs-box.vue